import { ProductCard as RecoveredProductCard } from 'src/scripts/components/cards/product-card/product-card'
import { $el } from 'src/scripts/utils/utils'

const QUICK_VIEW_SELECTOR = '#Quick-view'
const CAROUSEL_READY_EVENT = 'vl:carousel-ready'

export class ProductCard extends RecoveredProductCard {
  mobileCarousel?: any
  waitingMobileCarousel?: any

  unmountComponent(): void {
    this.waitingMobileCarousel?.removeEventListener(
      CAROUSEL_READY_EVENT,
      this.handleMobileCarouselReady,
    )
    this.mobileCarousel?.embla?.off('select', this.handleCarouselSelect)
    this.playingVideo?.pause()
    this.mobileCarousel = undefined
    this.waitingMobileCarousel = undefined
    this.playingVideo = null
    this.carouselInited = false
    super.unmountComponent()
  }

  initMobileCarousel = (): void => {
    if (this.carouselInited) return

    const carousel: any = $el('carousel-component', this)
    if (!carousel || !$el('video', carousel)) return

    if (!carousel.embla) {
      if (this.waitingMobileCarousel !== carousel) {
        this.waitingMobileCarousel?.removeEventListener(
          CAROUSEL_READY_EVENT,
          this.handleMobileCarouselReady,
        )
        carousel.addEventListener(
          CAROUSEL_READY_EVENT,
          this.handleMobileCarouselReady,
          { once: true },
        )
        this.waitingMobileCarousel = carousel
      }
      return
    }

    this.waitingMobileCarousel?.removeEventListener(
      CAROUSEL_READY_EVENT,
      this.handleMobileCarouselReady,
    )
    this.waitingMobileCarousel = undefined
    this.mobileCarousel?.embla?.off('select', this.handleCarouselSelect)
    this.mobileCarousel = carousel
    carousel.embla.on('select', this.handleCarouselSelect)
    this.carouselInited = true
  }

  handleMobileCarouselReady = (): void => {
    this.waitingMobileCarousel = undefined
    if (this.isConnected) this.initMobileCarousel()
  }

  async callQuickView(withOpen: boolean): Promise<void> {
    const bundle = window.VelotricBundle

    if (!bundle?.['quick-view']?.ready) {
      if (!bundle?.intent?.ready) return

      if (withOpen) this.setQuickViewLoading(true)

      try {
        await bundle.intent.loadFeature(
          'quickView',
          withOpen ? 'activation' : 'prewarm',
        )
      } catch {
        if (withOpen) this.setQuickViewLoading(false)
        return
      }
    }

    const quickView: any = $el(QUICK_VIEW_SELECTOR)
    const url = this.dataset.url
    const id = this.dataset.id

    if (!quickView?.requestProductFromUrl || !url || !id) {
      if (withOpen) this.setQuickViewLoading(false)
      return
    }

    await quickView.requestProductFromUrl(url, id)

    if (withOpen) {
      try {
        await quickView.openAndRenderProductByUrl(url)
      } finally {
        this.setQuickViewLoading(false)
      }
    }
  }

}
